import * as React from "react";
import styled from "styled-components";
import DocsHelper from "util/DocsHelper";
import DocumentationLink from "components/support/DocumentationLink";
import Panel from "components/bootstrap/Panel";
import Icon from "./Icon";
const Header = styled(Panel.Title)`
  display: flex;
  align-items: center;
`;
const HeaderIcon = styled(Icon)`
  margin-right: 5px;
  margin-top: -1px;
`;
const EnterprisePluginNotFound = ({ featureName, wrapperClassName = "no-bm" }) => /* @__PURE__ */ React.createElement(Panel, { bsStyle: "info", className: wrapperClassName }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(HeaderIcon, { name: "enterprise" }), "Enterprise Feature")), /* @__PURE__ */ React.createElement(Panel.Body, null, "To use the ", /* @__PURE__ */ React.createElement("b", null, featureName), " functionality you need the", " ", /* @__PURE__ */ React.createElement("a", { href: "https://www.graylog.org/products/enterprise", rel: "noopener noreferrer", target: "_blank" }, "Graylog Enterprise license"), " ", "and the ", /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.ENTERPRISE_SETUP, text: "Graylog Enterprise plugin" }), "."));
export default EnterprisePluginNotFound;
